var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const NestedSelect = (props) => {
    const { t } = useTranslation();
    const [selectedOption, setSelectedOption] = useState("");
    const [subOptions, setSubOptions] = useState([]);
    const [selectBarOpen, setSelectBarOpen] = useState(false);
    const [menuOptions, setMenuOptions] = useState([]);
    const [typeOfStructure, setTypeOfStructure] = useState("");
    useEffect(() => {
        let isMounted = true; // Add a flag to track whether the component is mounted
        setSelectBarOpen(props.selectOptionsOpen);
        const getInstitutionStructure = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield fetch("/livi/api/preuser/institution/structure");
                if (isMounted) {
                    // Check if the component is still mounted before updating the state
                    if (response.ok) {
                        const structure = yield response.json();
                        setMenuOptions([
                            {
                                label: t("addPeople.office"),
                                value: "office",
                                subMenu: structure.officeStructures.map((office) => office.name),
                            },
                            {
                                label: t("addPeople.department"),
                                value: "department",
                                subMenu: structure.departmentStructures.map((department) => department.name),
                            },
                            {
                                label: t("addPeople.position"),
                                value: "position",
                                subMenu: structure.positionStructures.map((job) => job.name),
                            },
                        ]);
                    }
                    else if (response.status < 500) {
                        console.log("Forbidden or Unauthorized action!", response.status);
                    }
                    else {
                        console.log("Server error occurred, try to contact server manager", response.status);
                    }
                }
            }
            catch (error) {
                if (isMounted) {
                    console.log("Something went wrong", error);
                }
            }
        });
        getInstitutionStructure();
        // Set the isMounted flag to false when the component unmounts
        return () => {
            isMounted = false;
        };
    }, [props.selectOptionsOpen]);
    const handleSelect = () => {
        setSelectedOption("");
        if (selectBarOpen === true) {
            setSubOptions([]);
        }
        setSelectBarOpen(!selectBarOpen);
    };
    const handleSuboptionClick = (value) => {
        const queryParameters = Object.assign(Object.assign({}, props.queryParameters), { [typeOfStructure]: value });
        setSubOptions([]);
        setSelectBarOpen(false);
        props.onQueryParametersChange(queryParameters);
    };
    const handleMainOptionClick = (subMenu, optionValue) => {
        setTypeOfStructure(optionValue);
        setSubOptions(subMenu);
    };
    // const handleMouseLeave = () => {
    //   setSubOptions([]);
    // }
    return (React.createElement("div", { className: "custom-dropdown nested-select" },
        React.createElement("div", { className: "select-box", onClick: handleSelect },
            React.createElement("div", { className: "selected-option" }, t("addPeople.select")),
            React.createElement("div", { className: "dropdown-arrow main" },
                React.createElement("i", { className: `arrow ${selectBarOpen ? "up" : "down"}` }))),
        selectBarOpen && (React.createElement("div", { className: "nested options" }, menuOptions.map((option) => (React.createElement("div", { key: option.value, className: "option", onClick: () => handleMainOptionClick(option.subMenu, option.value) },
            option.label,
            React.createElement("div", { className: "dropdown-arrow" },
                React.createElement("i", { className: `arrow ${typeOfStructure === option.value ? "right" : "down"}` }))))))),
        subOptions.length > 0 && (React.createElement("div", { className: `sub-menu ${typeOfStructure}` }, subOptions.map((subOption, index) => (React.createElement("div", { key: index, className: "sub-option", onClick: () => handleSuboptionClick(subOption) }, subOption)))))));
};
export default NestedSelect;
